import React from "react"
import { Modal, Button, Alert } from "react-bootstrap"
import axios from 'axios'

import * as organization from '../services/organization-service'

import Input from './Input'

export default class LogoModal extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.removeLogo = this.removeLogo.bind(this)
    this.import = this.import.bind(this)
    this.state = {
      logo: "",
      show: undefined
    }
  }

  handleShowmodal(logo) {
    this.setState({logo : logo.currentTarget.currentSrc}, () => this.handleShow())
  }

  handleShow() {
    this.setState({ show: true })
  }

  selectFile(property, file) {
    const filePath = file.name
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i
    if (!allowedExtensions.exec(filePath)) {
      this.setState({ message: "Het bestandstype is ongeldig. Selecteer een geldig bestandstype."})
    } else {
      this.setState({ message: undefined })
      this.file = file
    }
  }

  removeLogo() {
    organization.deletelogo().then(response => {
      this.handleHide()
    }).catch((error) => {
      this.setState({ status: 'ERROR', message: "Het logo is niet verwijderd" })
    })
  }

  uploadlogo() {
    let formData = new FormData()
    formData.append('file', this.file)
    axios.post('bw/organization/uploadlogo',
      formData,
      {
        headers: {
        'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(response => {
      this.handleHide()
    }).catch((error) => {
      this.setState({ status: 'ERROR', message: "Het bestand kan niet geüpload worden" })
    })
  }

  import() {
    this.uploadlogo()
  }

  handleHide() {
    this.setState({show: false, message: undefined }, this.props.reload())
  }

  render() {
    const { message } = this.state
    const { textbt } = this.props

    return (
      <div>
        <Button className="edit-entry action-btn" onClick={this.handleShow}>
          {textbt}
        </Button>

        {this.state.show &&
          <Modal
            show={this.state.show}
            onHide={this.handleHide}
            dialogClassName="custom-modal modal-new-employee"
            backdrop={false}>

            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">
                {this.props.title}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              { message && <Alert bsStyle='danger'>{message}</Alert> }
              <div>
                <p>Gebruik hiervoor een jpg, png of gif bestand van max. 1 MB.</p>
              </div>
              <div>
                <Input type="file" onChange={this.selectFile.bind(this)} ref={ref => this.fileUpload = ref} />
                <br/>
                <p>U kunt het logo op ieder moment wijzigen en of verwijderen.</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="primary" onClick={this.import}>Upload</Button>
              <Button onClick={this.removeLogo}>Verwijderen</Button>
              <Button onClick={this.handleHide}>Annuleren</Button>
            </Modal.Footer>
          </Modal>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LogoModal.js